// @generated by protoc-gen-es v2.11.0 with parameter "target=ts"
// @generated from file gitpod/v1/session.proto (package gitpod.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import { file_buf_validate_validate } from "../../buf/validate/validate_pb";
import { file_gitpod_tools_v1_logfields } from "../tools/v1/logfields_pb";
import type { PaginationRequest, PaginationResponse } from "./pagination_pb";
import { file_gitpod_v1_pagination } from "./pagination_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file gitpod/v1/session.proto.
 */
export const file_gitpod_v1_session: GenFile = /*@__PURE__*/
  fileDesc("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", [file_buf_validate_validate, file_gitpod_tools_v1_logfields, file_gitpod_v1_pagination]);

/**
 * @generated from message gitpod.v1.Session
 */
export type Session = Message<"gitpod.v1.Session"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: string description = 3;
   */
  description: string;

  /**
   * @generated from field: gitpod.v1.SessionPhase phase = 4;
   */
  phase: SessionPhase;

  /**
   * @generated from field: repeated gitpod.v1.SessionResource resources = 5;
   */
  resources: SessionResource[];

  /**
   * orchestrator_agent_execution_id is the agent execution that drives this session's name.
   * The first agent execution linked to a session becomes its orchestrator.
   *
   * @generated from field: string orchestrator_agent_execution_id = 6;
   */
  orchestratorAgentExecutionId: string;
};

/**
 * Describes the message gitpod.v1.Session.
 * Use `create(SessionSchema)` to create a new message.
 */
export const SessionSchema: GenMessage<Session> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_session, 0);

/**
 * @generated from message gitpod.v1.SessionResource
 */
export type SessionResource = Message<"gitpod.v1.SessionResource"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: gitpod.v1.SessionResourceKind kind = 2;
   */
  kind: SessionResourceKind;

  /**
   * @generated from field: gitpod.v1.SessionResourceRole role = 3;
   */
  role: SessionResourceRole;

  /**
   * @generated from field: optional string url = 6;
   */
  url?: string;

  /**
   * @generated from field: optional string title = 7;
   */
  title?: string;

  /**
   * @generated from field: optional string description = 8;
   */
  description?: string;
};

/**
 * Describes the message gitpod.v1.SessionResource.
 * Use `create(SessionResourceSchema)` to create a new message.
 */
export const SessionResourceSchema: GenMessage<SessionResource> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_session, 1);

/**
 * @generated from message gitpod.v1.CreateSessionRequest
 */
export type CreateSessionRequest = Message<"gitpod.v1.CreateSessionRequest"> & {
  /**
   * @generated from field: optional string name = 1;
   */
  name?: string;

  /**
   * @generated from field: optional string description = 2;
   */
  description?: string;
};

/**
 * Describes the message gitpod.v1.CreateSessionRequest.
 * Use `create(CreateSessionRequestSchema)` to create a new message.
 */
export const CreateSessionRequestSchema: GenMessage<CreateSessionRequest> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_session, 2);

/**
 * @generated from message gitpod.v1.CreateSessionResponse
 */
export type CreateSessionResponse = Message<"gitpod.v1.CreateSessionResponse"> & {
  /**
   * @generated from field: gitpod.v1.Session session = 1;
   */
  session?: Session;
};

/**
 * Describes the message gitpod.v1.CreateSessionResponse.
 * Use `create(CreateSessionResponseSchema)` to create a new message.
 */
export const CreateSessionResponseSchema: GenMessage<CreateSessionResponse> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_session, 3);

/**
 * @generated from message gitpod.v1.GetSessionRequest
 */
export type GetSessionRequest = Message<"gitpod.v1.GetSessionRequest"> & {
  /**
   * @generated from field: string session_id = 1;
   */
  sessionId: string;
};

/**
 * Describes the message gitpod.v1.GetSessionRequest.
 * Use `create(GetSessionRequestSchema)` to create a new message.
 */
export const GetSessionRequestSchema: GenMessage<GetSessionRequest> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_session, 4);

/**
 * @generated from message gitpod.v1.GetSessionResponse
 */
export type GetSessionResponse = Message<"gitpod.v1.GetSessionResponse"> & {
  /**
   * @generated from field: gitpod.v1.Session session = 1;
   */
  session?: Session;
};

/**
 * Describes the message gitpod.v1.GetSessionResponse.
 * Use `create(GetSessionResponseSchema)` to create a new message.
 */
export const GetSessionResponseSchema: GenMessage<GetSessionResponse> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_session, 5);

/**
 * @generated from message gitpod.v1.ListSessionsRequest
 */
export type ListSessionsRequest = Message<"gitpod.v1.ListSessionsRequest"> & {
  /**
   * @generated from field: gitpod.v1.PaginationRequest pagination = 1;
   */
  pagination?: PaginationRequest;

  /**
   * @generated from field: optional gitpod.v1.SessionPhase phase = 2;
   */
  phase?: SessionPhase;
};

/**
 * Describes the message gitpod.v1.ListSessionsRequest.
 * Use `create(ListSessionsRequestSchema)` to create a new message.
 */
export const ListSessionsRequestSchema: GenMessage<ListSessionsRequest> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_session, 6);

/**
 * @generated from message gitpod.v1.ListSessionsResponse
 */
export type ListSessionsResponse = Message<"gitpod.v1.ListSessionsResponse"> & {
  /**
   * @generated from field: gitpod.v1.PaginationResponse pagination = 1;
   */
  pagination?: PaginationResponse;

  /**
   * @generated from field: repeated gitpod.v1.Session sessions = 2;
   */
  sessions: Session[];
};

/**
 * Describes the message gitpod.v1.ListSessionsResponse.
 * Use `create(ListSessionsResponseSchema)` to create a new message.
 */
export const ListSessionsResponseSchema: GenMessage<ListSessionsResponse> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_session, 7);

/**
 * @generated from message gitpod.v1.UpdateSessionRequest
 */
export type UpdateSessionRequest = Message<"gitpod.v1.UpdateSessionRequest"> & {
  /**
   * @generated from field: string session_id = 1;
   */
  sessionId: string;

  /**
   * @generated from field: optional string name = 2;
   */
  name?: string;

  /**
   * @generated from field: optional string description = 3;
   */
  description?: string;

  /**
   * @generated from field: optional gitpod.v1.SessionPhase phase = 4;
   */
  phase?: SessionPhase;

  /**
   * @generated from field: optional string orchestrator_agent_execution_id = 5;
   */
  orchestratorAgentExecutionId?: string;
};

/**
 * Describes the message gitpod.v1.UpdateSessionRequest.
 * Use `create(UpdateSessionRequestSchema)` to create a new message.
 */
export const UpdateSessionRequestSchema: GenMessage<UpdateSessionRequest> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_session, 8);

/**
 * @generated from message gitpod.v1.UpdateSessionResponse
 */
export type UpdateSessionResponse = Message<"gitpod.v1.UpdateSessionResponse"> & {
  /**
   * @generated from field: gitpod.v1.Session session = 1;
   */
  session?: Session;
};

/**
 * Describes the message gitpod.v1.UpdateSessionResponse.
 * Use `create(UpdateSessionResponseSchema)` to create a new message.
 */
export const UpdateSessionResponseSchema: GenMessage<UpdateSessionResponse> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_session, 9);

/**
 * @generated from message gitpod.v1.DeleteSessionRequest
 */
export type DeleteSessionRequest = Message<"gitpod.v1.DeleteSessionRequest"> & {
  /**
   * @generated from field: string session_id = 1;
   */
  sessionId: string;

  /**
   * @generated from field: bool force = 2;
   */
  force: boolean;
};

/**
 * Describes the message gitpod.v1.DeleteSessionRequest.
 * Use `create(DeleteSessionRequestSchema)` to create a new message.
 */
export const DeleteSessionRequestSchema: GenMessage<DeleteSessionRequest> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_session, 10);

/**
 * @generated from message gitpod.v1.DeleteSessionResponse
 */
export type DeleteSessionResponse = Message<"gitpod.v1.DeleteSessionResponse"> & {
};

/**
 * Describes the message gitpod.v1.DeleteSessionResponse.
 * Use `create(DeleteSessionResponseSchema)` to create a new message.
 */
export const DeleteSessionResponseSchema: GenMessage<DeleteSessionResponse> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_session, 11);

/**
 * @generated from message gitpod.v1.AddSessionResourceRequest
 */
export type AddSessionResourceRequest = Message<"gitpod.v1.AddSessionResourceRequest"> & {
  /**
   * @generated from field: string session_id = 1;
   */
  sessionId: string;

  /**
   * @generated from field: gitpod.v1.SessionResourceKind kind = 2;
   */
  kind: SessionResourceKind;

  /**
   * @generated from field: gitpod.v1.SessionResourceRole role = 3;
   */
  role: SessionResourceRole;

  /**
   * @generated from field: string url = 6;
   */
  url: string;

  /**
   * @generated from field: string title = 7;
   */
  title: string;

  /**
   * @generated from field: string description = 8;
   */
  description: string;
};

/**
 * Describes the message gitpod.v1.AddSessionResourceRequest.
 * Use `create(AddSessionResourceRequestSchema)` to create a new message.
 */
export const AddSessionResourceRequestSchema: GenMessage<AddSessionResourceRequest> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_session, 12);

/**
 * @generated from message gitpod.v1.AddSessionResourceResponse
 */
export type AddSessionResourceResponse = Message<"gitpod.v1.AddSessionResourceResponse"> & {
  /**
   * @generated from field: gitpod.v1.SessionResource resource = 1;
   */
  resource?: SessionResource;
};

/**
 * Describes the message gitpod.v1.AddSessionResourceResponse.
 * Use `create(AddSessionResourceResponseSchema)` to create a new message.
 */
export const AddSessionResourceResponseSchema: GenMessage<AddSessionResourceResponse> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_session, 13);

/**
 * @generated from message gitpod.v1.RemoveSessionResourceRequest
 */
export type RemoveSessionResourceRequest = Message<"gitpod.v1.RemoveSessionResourceRequest"> & {
  /**
   * @generated from field: string session_id = 1;
   */
  sessionId: string;

  /**
   * @generated from field: string resource_id = 2;
   */
  resourceId: string;
};

/**
 * Describes the message gitpod.v1.RemoveSessionResourceRequest.
 * Use `create(RemoveSessionResourceRequestSchema)` to create a new message.
 */
export const RemoveSessionResourceRequestSchema: GenMessage<RemoveSessionResourceRequest> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_session, 14);

/**
 * @generated from message gitpod.v1.RemoveSessionResourceResponse
 */
export type RemoveSessionResourceResponse = Message<"gitpod.v1.RemoveSessionResourceResponse"> & {
};

/**
 * Describes the message gitpod.v1.RemoveSessionResourceResponse.
 * Use `create(RemoveSessionResourceResponseSchema)` to create a new message.
 */
export const RemoveSessionResourceResponseSchema: GenMessage<RemoveSessionResourceResponse> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_session, 15);

/**
 * @generated from message gitpod.v1.UpdateSessionResourceRequest
 */
export type UpdateSessionResourceRequest = Message<"gitpod.v1.UpdateSessionResourceRequest"> & {
  /**
   * @generated from field: string session_id = 1;
   */
  sessionId: string;

  /**
   * @generated from field: string resource_id = 2;
   */
  resourceId: string;

  /**
   * @generated from field: optional gitpod.v1.SessionResourceRole role = 3;
   */
  role?: SessionResourceRole;

  /**
   * @generated from field: optional string title = 4;
   */
  title?: string;

  /**
   * @generated from field: optional string description = 5;
   */
  description?: string;
};

/**
 * Describes the message gitpod.v1.UpdateSessionResourceRequest.
 * Use `create(UpdateSessionResourceRequestSchema)` to create a new message.
 */
export const UpdateSessionResourceRequestSchema: GenMessage<UpdateSessionResourceRequest> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_session, 16);

/**
 * @generated from message gitpod.v1.UpdateSessionResourceResponse
 */
export type UpdateSessionResourceResponse = Message<"gitpod.v1.UpdateSessionResourceResponse"> & {
  /**
   * @generated from field: gitpod.v1.SessionResource resource = 1;
   */
  resource?: SessionResource;
};

/**
 * Describes the message gitpod.v1.UpdateSessionResourceResponse.
 * Use `create(UpdateSessionResourceResponseSchema)` to create a new message.
 */
export const UpdateSessionResourceResponseSchema: GenMessage<UpdateSessionResourceResponse> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_session, 17);

/**
 * @generated from message gitpod.v1.ListSessionResourcesRequest
 */
export type ListSessionResourcesRequest = Message<"gitpod.v1.ListSessionResourcesRequest"> & {
  /**
   * @generated from field: string session_id = 1;
   */
  sessionId: string;

  /**
   * @generated from field: optional gitpod.v1.SessionResourceKind kind = 2;
   */
  kind?: SessionResourceKind;

  /**
   * @generated from field: gitpod.v1.PaginationRequest pagination = 3;
   */
  pagination?: PaginationRequest;
};

/**
 * Describes the message gitpod.v1.ListSessionResourcesRequest.
 * Use `create(ListSessionResourcesRequestSchema)` to create a new message.
 */
export const ListSessionResourcesRequestSchema: GenMessage<ListSessionResourcesRequest> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_session, 18);

/**
 * @generated from message gitpod.v1.ListSessionResourcesResponse
 */
export type ListSessionResourcesResponse = Message<"gitpod.v1.ListSessionResourcesResponse"> & {
  /**
   * @generated from field: gitpod.v1.PaginationResponse pagination = 1;
   */
  pagination?: PaginationResponse;

  /**
   * @generated from field: repeated gitpod.v1.SessionResource resources = 2;
   */
  resources: SessionResource[];
};

/**
 * Describes the message gitpod.v1.ListSessionResourcesResponse.
 * Use `create(ListSessionResourcesResponseSchema)` to create a new message.
 */
export const ListSessionResourcesResponseSchema: GenMessage<ListSessionResourcesResponse> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_session, 19);

/**
 * @generated from enum gitpod.v1.SessionPhase
 */
export enum SessionPhase {
  /**
   * @generated from enum value: SESSION_PHASE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: SESSION_PHASE_ACTIVE = 1;
   */
  ACTIVE = 1,

  /**
   * @generated from enum value: SESSION_PHASE_ARCHIVED = 2;
   */
  ARCHIVED = 2,
}

/**
 * Describes the enum gitpod.v1.SessionPhase.
 */
export const SessionPhaseSchema: GenEnum<SessionPhase> = /*@__PURE__*/
  enumDesc(file_gitpod_v1_session, 0);

/**
 * @generated from enum gitpod.v1.SessionResourceKind
 */
export enum SessionResourceKind {
  /**
   * @generated from enum value: SESSION_RESOURCE_KIND_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: SESSION_RESOURCE_KIND_ISSUE = 3;
   */
  ISSUE = 3,

  /**
   * @generated from enum value: SESSION_RESOURCE_KIND_PULL_REQUEST = 4;
   */
  PULL_REQUEST = 4,

  /**
   * @generated from enum value: SESSION_RESOURCE_KIND_DOCUMENTATION = 5;
   */
  DOCUMENTATION = 5,
}

/**
 * Describes the enum gitpod.v1.SessionResourceKind.
 */
export const SessionResourceKindSchema: GenEnum<SessionResourceKind> = /*@__PURE__*/
  enumDesc(file_gitpod_v1_session, 1);

/**
 * @generated from enum gitpod.v1.SessionResourceRole
 */
export enum SessionResourceRole {
  /**
   * @generated from enum value: SESSION_RESOURCE_ROLE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: SESSION_RESOURCE_ROLE_OWNED = 1;
   */
  OWNED = 1,

  /**
   * @generated from enum value: SESSION_RESOURCE_ROLE_PRIMARY = 2;
   */
  PRIMARY = 2,

  /**
   * @generated from enum value: SESSION_RESOURCE_ROLE_SUBAGENT = 3;
   */
  SUBAGENT = 3,

  /**
   * @generated from enum value: SESSION_RESOURCE_ROLE_FIXES = 4;
   */
  FIXES = 4,

  /**
   * @generated from enum value: SESSION_RESOURCE_ROLE_BLOCKED_BY = 5;
   */
  BLOCKED_BY = 5,

  /**
   * @generated from enum value: SESSION_RESOURCE_ROLE_BLOCKS = 6;
   */
  BLOCKS = 6,

  /**
   * @generated from enum value: SESSION_RESOURCE_ROLE_REVIEWS = 7;
   */
  REVIEWS = 7,

  /**
   * @generated from enum value: SESSION_RESOURCE_ROLE_CREATED = 8;
   */
  CREATED = 8,

  /**
   * @generated from enum value: SESSION_RESOURCE_ROLE_REFERENCES = 9;
   */
  REFERENCES = 9,
}

/**
 * Describes the enum gitpod.v1.SessionResourceRole.
 */
export const SessionResourceRoleSchema: GenEnum<SessionResourceRole> = /*@__PURE__*/
  enumDesc(file_gitpod_v1_session, 2);

/**
 * @generated from service gitpod.v1.SessionService
 */
export const SessionService: GenService<{
  /**
   * @generated from rpc gitpod.v1.SessionService.CreateSession
   */
  createSession: {
    methodKind: "unary";
    input: typeof CreateSessionRequestSchema;
    output: typeof CreateSessionResponseSchema;
  },
  /**
   * @generated from rpc gitpod.v1.SessionService.GetSession
   */
  getSession: {
    methodKind: "unary";
    input: typeof GetSessionRequestSchema;
    output: typeof GetSessionResponseSchema;
  },
  /**
   * @generated from rpc gitpod.v1.SessionService.ListSessions
   */
  listSessions: {
    methodKind: "unary";
    input: typeof ListSessionsRequestSchema;
    output: typeof ListSessionsResponseSchema;
  },
  /**
   * @generated from rpc gitpod.v1.SessionService.UpdateSession
   */
  updateSession: {
    methodKind: "unary";
    input: typeof UpdateSessionRequestSchema;
    output: typeof UpdateSessionResponseSchema;
  },
  /**
   * @generated from rpc gitpod.v1.SessionService.DeleteSession
   */
  deleteSession: {
    methodKind: "unary";
    input: typeof DeleteSessionRequestSchema;
    output: typeof DeleteSessionResponseSchema;
  },
  /**
   * @generated from rpc gitpod.v1.SessionService.AddSessionResource
   */
  addSessionResource: {
    methodKind: "unary";
    input: typeof AddSessionResourceRequestSchema;
    output: typeof AddSessionResourceResponseSchema;
  },
  /**
   * @generated from rpc gitpod.v1.SessionService.RemoveSessionResource
   */
  removeSessionResource: {
    methodKind: "unary";
    input: typeof RemoveSessionResourceRequestSchema;
    output: typeof RemoveSessionResourceResponseSchema;
  },
  /**
   * @generated from rpc gitpod.v1.SessionService.UpdateSessionResource
   */
  updateSessionResource: {
    methodKind: "unary";
    input: typeof UpdateSessionResourceRequestSchema;
    output: typeof UpdateSessionResourceResponseSchema;
  },
  /**
   * @generated from rpc gitpod.v1.SessionService.ListSessionResources
   */
  listSessionResources: {
    methodKind: "unary";
    input: typeof ListSessionResourcesRequestSchema;
    output: typeof ListSessionResourcesResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_gitpod_v1_session, 0);

